<template>
  <v-app v-if="articleInfoValue">
    <v-container fluid class="article-actions">
      <b-alert
        :variant="variant"
        v-model="showValidationAlert"
        dismissible
        style="
          position: fixed;
          width: 100%;
          z-index: 99999;
          top: 75px;
          right: 0;
        "
      >
        {{ alertMsg }}</b-alert
      >
      <v-row>
        <v-col md="2">
          <v-subheader>عنوان</v-subheader>
        </v-col>
        <v-col md="8">
          <v-text-field placeholder="عنوان" v-model="title"
            :rules="[() => !!title || 'این فیلد الزامی است']"
            required
            :error-messages="errorMessages"
             ref="title"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="2">
          <v-subheader>ترتیب نمایش</v-subheader>
        </v-col>
        <v-col md="8">
          <v-text-field
            placeholder="ترتیب نمایش"
            v-model="priority"
            :rules="[() => !!priority || 'این فیلد الزامی است']"
            required
            :error-messages="errorMessages"
             ref="priority"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="2">
          <v-subheader>برند ها</v-subheader>
        </v-col>
        <v-col md="8">
          <v-combobox
            v-model="select"
            :items="items"
            label="برند ها"
            multiple
            dense
            reverse
            chips
          ></v-combobox>
        </v-col>
      </v-row>
      <!-- <v-row>
        <v-col md="2">
          <v-subheader>ویژگی ها</v-subheader>
        </v-col>
        <v-col md="8">
          <v-combobox
            v-model="select1"
            :items="items1"
            label="ویژگی ها"
            multiple
            dense
            reverse
            chips
          ></v-combobox>
        </v-col>
      </v-row> -->
      <v-row
        ><v-col md="2">
          <v-subheader>دسته بندی</v-subheader>
        </v-col>
        <v-col md="8">
          <Treeview
            :items="categoryList"
            @productCategory="
              (e) => {
                productParentId = e;
              }
            "
          />
        </v-col>
      </v-row>
      <v-row
        ><v-col md="2">
          <v-subheader>تصویر</v-subheader>
        </v-col>
        <v-col md="8">
          <ImageUploader :imageUrl="image" @image-file="imageFile" />
        </v-col>
      </v-row>
      <v-row
        ><v-col md="2">
          <v-subheader>نمایش در صفحه اصلی</v-subheader>
        </v-col>
        <v-col md="8">
          <v-switch
            v-model="showInLanding"
            color="indigo darken-3"
            hide-details
          ></v-switch>
        </v-col>
      </v-row>
      <v-row justify="center mb-3">
        <v-btn
          class="ml-4 white--text font-weight-bold indigo darken-4 white--text"
          @click="editHandler"
        >
          ثبت کردن
        </v-btn>
        <router-link to="/product-management/category">
          <v-btn class="white--text font-weight-bold indigo lighten-2">
            انصراف
          </v-btn>
        </router-link>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import baseURL from "@/axios";
import Treeview from "./components/Treeview.vue";
import ImageUploader from "./components/ImageUploadAdd.vue";
export default {
  components: { Treeview, ImageUploader },

  created() {
    ///Get All Brands
    axios.get(`${baseURL}Brand/GetAll`).then((res) => {
      res.data.data.map((item) => {
        this.items.push({
          text: item.name,
          value: item.id,
        });
      });
    });
    ///Get All Feature
    axios.get(`${baseURL}Feature/GetAll`).then((res) => {
      res.data.data.map((item) => {
        this.items1.push({
          text: item.title,
          value: item.id,
        });
      });
    });
    // Get Products
    axios.get(`${baseURL}ProductGroup/GetAll`).then((res) => {
      this.categoryList = res.data.data;
    });
  },

  data() {
    return {
      id: null,
      parentId: "",
      link: "",
      staticContentTypeId: 0,
      title: "",
      image: null,
      list: [],
      selectItem: "null",
      priority: null,
      select: [],
      select1: [],
      items: [],
      items1: [],
      categoryList: [],
      productParentId: null,
      showInLanding: false,

      errorMessages: "",

      formHasErrors: false,
      showValidationAlert: false,
      variant: "",
      alertMsg: "",
    };
  },
  watch: {
    title() {
      this.errorMessages = "";
    },
  },
  computed: {
    ...mapGetters(["tokenValue", "articleInfoValue", "itemList"]),
    form() {
      return {
        title: this.title,
        priority: this.priority,
      };
    },
  },
  methods: {
    onFileSelected(event) {
      this.image = event.target.files[0];
    },
    imageFile(value) {
      this.imageFile = value;
    },
    async editHandler() {
      this.formHasErrors = false;
      Object.keys(this.form).forEach((f) => {
        if (!this.form[f]) {
          this.formHasErrors = true;
        } else {
          // this.$refs[f].validate(true);
        }
      });
      if (!this.formHasErrors) {
      this.list.map((item) => {
        if (item.title == this.selectItem) {
          this.selectItem = item.id;
        }
      });
      const brands = [];
      const features = [];
      this.select.map((item) => {
        brands.push(item.value);
      });
      this.select1.map((item) => {
        features.push(item.value);
      });
      ////////console.log(brands,features)
      await axios
        .post(
          `${baseURL}ProductGroup/Add`,
          {
            id: this.id,
            title: this.title,
            parentId: this.productParentId,
            priority: this.priority,
            showInIndex: this.showInLanding,
            brandIds: brands,
            featureIds: features,
          },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        )
        .then((res) => {
          // this.$router.push("/product-management/shippingPrice");

          const fd = new FormData();
          fd.append("image", this.imageFile);
          ////////console.log(typeof(fd))
          axios
            .post(
              `${baseURL}ProductGroup/UploadImage?id=${res.data.data.id}`,
              fd,
              {
                headers: {
                  Authorization: `Bearer ${sessionStorage.getItem(
                    "token"
                  )}`,
                  "Content-Type": "multipart/form-data",
                },
              }
            ).then((res) => {
                this.showValidationAlert = true;
                this.variant = "success";
                this.alertMsg = res.data.message;
                setTimeout(() => {
                  this.$router.push("/product-management/category");
                }, 3000);
              })
              .catch((e) => {
                this.showValidationAlert = true;
                this.variant = "danger";
                this.alertMsg = e.response.data.message;
              });
          })
          .catch((err) => {
            this.showValidationAlert = true;
            this.variant = "danger";
            this.alertMsg = err.response.data.message;
          });
      } else {
        this.showValidationAlert = true;
        this.variant = "danger";
        this.alertMsg = "لطفا تمامی فیلد های خواسته شده را پر کنید";
      }
    },
    treeHandler(e) {
      this.productParentId = e;
    },
  },
};
</script>

    // axios
    //   .get(`${baseURL}ProductGroup/GetById?id=${this.$route.params.id}`)
    //   .then((res) => {
    //     this.title = res.data.data.title;
    //     this.image = res.data.data.image;
    //     this.tags = res.data.data.tags;
    //     this.priority = res.data.data.priority;
    //     res.data.data.brands.map((item) => this.select.push(item.name));
    //     res.data.data.features.map((item) => this.select1.push(item.title));
    //   });

<style>
.article-actions {
  background: #ffffff;
  height: auto;
}
.v-input__control {
  direction: ltr;
}
.v-input__slot {
  flex-direction: row-reverse;
}
.v-application--wrap {
  min-height: auto !important;
}
.theme--light.v-input input {
  text-align: right;
}
</style>